import React, { useState } from "react";
import PropTypes from "prop-types";
import { useHistory, Link } from "react-router-dom";
import classNames from "classnames";
import useNetworkStatus from "utils/useNetworkStatus";
import Observations from "../Observations";
import { PICKUP_STATUS } from "pages/Picking/usePicking";
import ShowTimeInHoursAndMins from "components/ShowTimeInHoursAndMins";
import PhotoInput from "components/PhotoInput";
import TimeslotDisplay from "./ETADisplay";

const isFinalEvent = (event) => {
  const finalEvents = [
    "ITM_DELIVERY_PARTIALLY_RETURNED_TO_STORE",
    "ITM_DELIVERY_NOT_COMPLIANT",
    "ITM_DELIVERY_COMPLIANT",
  ];

  return finalEvents.includes(event);
};

const DeliveryItem = ({
  item,
  isReordering,
  isLastItem,
  updatePosition,
  setModalReturnModalIsOpen,
  isOrderReturned = false,
  halfDay,
  correspondingPickingId,
}) => {
  const isOnline = useNetworkStatus();
  const isValidated = Boolean(item.delivered);
  const isDelayed = Boolean(item.isDelayed);
  const someArticleHaveNotBeenDelivered = Boolean(
    item.someArticleHaveNotBeenDelivered
  );
  const displayButtonArticlesReturnedToStore =
    (someArticleHaveNotBeenDelivered || item.customerIsAbsent) &&
    !isFinalEvent(item.order.last_event) &&
    !isOrderReturned;
  const history = useHistory();

  // Photo capture state
  const [showPhotoInput, setShowPhotoInput] = useState(false);

  const handlePhotoTaken = (photoBase64) => {
    // Store the photo with timestamp and navigate to delivery form
    const timestamp = new Date().toISOString();
    // TODO: Store the photo data (this would typically be saved to local storage or state management)
    console.log("Arrival photo taken:", {
      photoBase64,
      timestamp,
      deliveryId: item.id,
    });

    setShowPhotoInput(false);
    // Navigate to delivery form after photo is taken
    history.push(`/delivery/${item.id}`);
  };

  const pickingButtonClasses = classNames("delivery-item__picking-btn", {
    "delivery-item__picking-btn--completed":
      item.order.picking_status === PICKUP_STATUS.PICKUP_OK.value,
    "delivery-item__picking-btn--partially":
      item.order.picking_status === PICKUP_STATUS.PICKUP_PARTIALLY.value,
    "delivery-item__picking-btn--failed":
      item.order.picking_status === PICKUP_STATUS.PICKUP_FAILED.value,
    "delivery-item__picking-btn--delivery-completed-without-picking":
      !item.order.picking_status && isValidated,
  });

  const hasInstallArticle = item.order.articles.some(
    ({ install_article }) => install_article
  );
  const hasDirectDropOff = item.order.articles.some(
    ({ direct_drop_article }) => direct_drop_article
  );

  const hasDropOff = item.order.articles.some(
    ({ drop_article }) => drop_article
  );

  const haveHeavyPackage = item.order.articles.some(
    ({ has_heavy_package }) => has_heavy_package
  );
  const numberOfPackages = item.order.articles.reduce(
    (acc, { number_of_packages }) => acc + number_of_packages,
    0
  );

  const isLongTermRental = item.order.is_long_term_rental > 0;

  return (
    <div className="delivery-item">
      <Link
        to={`/delivery/${item.id}`}
        onClick={(e) => {
          if (isReordering) {
            e.preventDefault();
          }
        }}
      >
        <div
          className={`round-delivery-item ${isValidated ? "-validated" : ""} ${
            isDelayed ? "-delayed" : ""
          }`}
        >
          {/* {isValidated && (
            <i
              className={`fa ${
                isDelayed ? "fa-sync" : "fa-check-circle"
              } fa-lg validationIcon`}
              aria-hidden="true"
            />
          )} */}

          {/* <i
            className={`accessory fa fa-chevron-right ${
              isReordering ? "hidden" : ""
            }`}
            aria-hidden="true"
          /> */}

          {isReordering && (
            <div>
              {Number(item.position) !== 1 && (
                <button
                  type="button"
                  className="reorder -up button button-outline"
                  onClick={updatePosition({
                    halfDay,
                    item,
                    direction: "UP",
                  })}
                >
                  <i className="fa fa-arrow-up" aria-hidden="true" />
                </button>
              )}
              {!isLastItem && (
                <button
                  type="button"
                  className="reorder -down button button-outline"
                  onClick={updatePosition({
                    halfDay,
                    item,
                    direction: "DOWN",
                  })}
                >
                  <i className="fa fa-arrow-down" aria-hidden="true" />
                </button>
              )}
            </div>
          )}

          <div className="row">
            <div className="column column-50">
              <div>
                <span className="label">Magasin</span> :{" "}
                {item.order.contractor.identity.code}
              </div>
            </div>
            <div className="column column-50">
              <div>
                <span className="label">Référence</span> :{" "}
                {item.order.reference}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="column">
              <span className="label">
                {+item.order.store_return ? "RETOUR MAGASIN" : "Client"}
              </span>{" "}
              : {item.order.client.identity.lastname}
            </div>
          </div>

          <Observations order={item.order} />

          <div className="delivery-options">
            {hasDropOff && <i className="fa fa-truck" title="Dépose" />}
            {hasDirectDropOff && (
              <i
                className="fas solid fa-door-closed"
                title="Pas de porte (pavillon), pied d'immeuble"
              ></i>
            )}
            {hasInstallArticle && (
              <i
                className="fas fa-screwdriver"
                title="Installation / Montage"
              ></i>
            )}
            {haveHeavyPackage && (
              <i
                className="fas fa-weight-hanging"
                title="Colis lourd"
                style={{ color: "red" }}
              ></i>
            )}
            {numberOfPackages > 0 && (
              <>
                <i className="fas fa-cubes" title="Colis multiple">
                  {" "}
                  {numberOfPackages}{" "}
                </i>
              </>
            )}
            {isLongTermRental && (
              <i
                className="fas fa-credit-card"
                title="Location longue durée"
                style={{
                  color: item.order.is_long_term_rental === 1 ? "red" : "green",
                }}
              />
            )}
            {/* {item?.order?.overridden_driving_time && (
              <i className="fas fa-road" title="Temps de conduite">
                {" "}
                {ShowTimeInHoursAndMins({
                  time: item?.order?.overridden_driving_time,
                  returnText: true,
                })}
              </i>
            )} */}

            <TimeslotDisplay
              fromTime={item.order.delivery.from_time}
              toTime={item.order.delivery.to_time}
              estimatedArrivalTime={item.estimatedArrivalTime}
              isSmsSent={item.isSmsSent}
              isDelivered={isValidated}
            />

            {item?.order?.road_time !== null && (
              <i
                className="fas fa-road road-time-icon"
                title="Temps de conduite"
              >
                {" "}
                {ShowTimeInHoursAndMins({
                  time: item?.order?.road_time / 60,
                  returnText: true,
                })}{" "}
                - {(item.order.road_distance / 1000).toFixed(1)}km
              </i>
            )}
          </div>

          <div className="delivery-item__actions">
            <div className="delivery-item__actions-left">
              <i
                className={`fa fa-dolly fa-lg clickable-icon ${pickingButtonClasses}`}
                aria-hidden="true"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const {
                    id: orderId,
                    order: {
                      delivery: { date: orderDate },
                    },
                  } = item;
                  history.push(`/picking/${correspondingPickingId}`, {
                    orderId,
                    orderDate,
                    orderHalfDay: halfDay,
                  });
                }}
                title="Picking"
              />
              <i
                className="fas fa-phone fa-lg clickable-icon phone-icon"
                aria-hidden="true"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const phoneNumber = item.order.client.identity.phone;
                  if (phoneNumber) {
                    window.open(`tel:${phoneNumber}`, "_blank");
                  }
                }}
                style={{ cursor: "pointer" }}
                title="Call Client"
              />

              {displayButtonArticlesReturnedToStore && (
                <i
                  className="fas fa-store fa-lg clickable-icon"
                  aria-hidden="true"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setModalReturnModalIsOpen({ item });
                  }}
                  style={{ cursor: "pointer" }}
                  title="Indiquer les articles directement retournés en magasin"
                />
              )}
            </div>

            <div className="delivery-item__actions-right">
              <span className="tiny-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  width="24"
                  fill="#20274a"
                  height="24"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const lat = item.order.client.address?.lat;
                    const lng = item.order.client.address?.lng;
                    if (lat && lng) {
                      window.open(
                        `waze://?ll=${lat},${lng}&navigate=yes`,
                        "_blank"
                      );
                    }
                  }}
                  style={{ cursor: "pointer" }}
                  title="Navigate with Waze"
                >
                  <path d="M502.2 201.7C516.7 287.5 471.2 369.6 389 409.8c13 34.1-12.4 70.2-48.3 70.2a51.7 51.7 0 0 1 -51.6-49c-6.4 .2-64.2 0-76.3-.6A51.7 51.7 0 0 1 159 479.9c-33.9-1.4-58-34.8-47-67.9-37.2-13.1-72.5-34.9-99.6-70.8-13-17.3-.5-41.8 20.8-41.8 46.3 0 32.2-54.2 43.2-110.3C94.8 95.2 193.1 32 288.1 32c102.5 0 197.2 70.7 214.1 169.7zM373.5 388.3c42-19.2 81.3-56.7 96.3-102.1 40.5-123.1-64.2-228-181.7-228-83.5 0-170.3 55.4-186.1 136-9.5 48.9 5 131.4-68.8 131.4C58.2 358.6 91.6 378.1 127 389.5c24.7-21.8 63.9-15.5 79.8 14.3 14.2 1 79.2 1.2 87.9 .8a51.7 51.7 0 0 1 78.8-16.4zM205.1 187.1c0-34.7 50.8-34.8 50.8 0s-50.8 34.7-50.8 0zm116.6 0c0-34.7 50.9-34.8 50.9 0s-50.9 34.8-50.9 0zm-122.6 70.7c-3.4-16.9 22.2-22.2 25.6-5.2l.1 .3c4.1 21.4 29.9 44 64.1 43.1 35.7-.9 59.3-22.2 64.1-42.8 4.5-16.1 28.6-10.4 25.5 6-5.2 22.2-31.2 62-91.5 62.9-42.6 0-80.9-27.8-87.9-64.3z" />
                </svg>
              </span>
              <span className="tiny-icon">
                <svg
                  id="Layer_1"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 230.92 331"
                  width="24"
                  height="24"
                  fill="#20274a"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const lat = item.order.client.address?.lat;
                    const lng = item.order.client.address?.lng;
                    if (lat && lng) {
                      window.open(
                        `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving&dir_action=navigate`,
                        "_blank"
                      );
                    }
                  }}
                  style={{ cursor: "pointer" }}
                  title="Navigate with Google Maps"
                >
                  <path
                    d="M418.92,223.86a115.69,115.69,0,0,0-123.33,35.86l54.55,45.86Z"
                    transform="translate(-268.54 -218.5)"
                    style={{ fill: "#1a73e8" }}
                  />
                  <path
                    d="M295.58,259.72a115.07,115.07,0,0,0-27,74.21c0,21.69,4.31,39.33,11.43,55.07l70.16-83.42Z"
                    transform="translate(-268.54 -218.5)"
                    style={{ fill: "#ea4335" }}
                  />
                  <path
                    d="M384,289.83a44.17,44.17,0,0,1,33.71,72.71l68.72-81.72a115.52,115.52,0,0,0-67.61-56.9l-68.66,81.72A44,44,0,0,1,384,289.83"
                    transform="translate(-268.54 -218.5)"
                    style={{ fill: "#4285f4" }}
                  />
                  <path
                    d="M384,378.15a44.14,44.14,0,0,1-33.84-72.51L280,389.06c12,26.59,31.94,47.95,52.46,74.86l85.31-101.38A44.11,44.11,0,0,1,384,378.15"
                    transform="translate(-268.54 -218.5)"
                    style={{ fill: "#fbbc04" }}
                  />
                  <path
                    d="M416,491.56c38.54-60.23,83.42-87.6,83.42-157.63a115,115,0,0,0-13-53.24l-154,183.24c6.53,8.56,13.13,17.64,19.53,27.7,23.39,36.19,16.92,57.88,32,57.88s8.62-21.75,32-57.94"
                    transform="translate(-268.54 -218.5)"
                    style={{ fill: "#34a853" }}
                  />
                </svg>
              </span>
            </div>
          </div>

          {isDelayed && !isOnline ? (
            <h4>
              Cette commande sera synchronisée avec le serveur une fois la
              connexion à internet rétablie
            </h4>
          ) : null}
        </div>
      </Link>
      <PhotoInput
        open={showPhotoInput}
        setOpen={setShowPhotoInput}
        onTakePhotoSuccessful={handlePhotoTaken}
      />
    </div>
  );
};

DeliveryItem.propTypes = {
  isOrderReturned: PropTypes.bool,
  item: PropTypes.shape({
    position: PropTypes.string.isRequired,
    customerIsAbsent: PropTypes.bool,
    delivered: PropTypes.string,
    estimatedArrivalTime: PropTypes.string,
    isDelayed: PropTypes.bool.isRequired,
    isSmsSent: PropTypes.bool.isRequired,
    someArticleHaveNotBeenDelivered: PropTypes.bool,
    id: PropTypes.string.isRequired,
    order: PropTypes.shape({
      last_event: PropTypes.string,
      road_time: PropTypes.number,
      road_distance: PropTypes.number,
      overridden_driving_time: PropTypes.string,
      is_long_term_rental: PropTypes.number,
      articles: PropTypes.arrayOf(
        PropTypes.shape({
          article: PropTypes.shape({
            install_article: PropTypes.bool,
          }).isRequired,
        }).isRequired
      ).isRequired,
      contractor: PropTypes.shape({
        identity: PropTypes.shape({ code: PropTypes.string.isRequired })
          .isRequired,
      }).isRequired,
      reference: PropTypes.string.isRequired,
      store_return: PropTypes.bool.isRequired,
      client: PropTypes.shape({
        identity: PropTypes.shape({
          lastname: PropTypes.string.isRequired,
          phone: PropTypes.string,
        }).isRequired,
        address: PropTypes.shape({
          lat: PropTypes.number,
          lng: PropTypes.number,
        }),
      }),
      delivery: PropTypes.shape({
        date: PropTypes.string.isRequired,
        from_time: PropTypes.string.isRequired,
        to_time: PropTypes.string.isRequired,
      }).isRequired,
      picking_status: PropTypes.string,
    }).isRequired,
  }).isRequired,
  isReordering: PropTypes.bool.isRequired,
  isLastItem: PropTypes.bool.isRequired,
  updatePosition: PropTypes.func.isRequired,
  setModalReturnModalIsOpen: PropTypes.func.isRequired,
  halfDay: PropTypes.string.isRequired,
  correspondingPickingId: PropTypes.string.isRequired,
};

export default DeliveryItem;
